import { Dispatch } from "react";
import { IntervalModel, SchoolModel } from "model";

export const ReportIssueKey = {
  ReportIssueFormPanel: "report-issue-form-panel",
  ReportIssueConfirmPanel: "report-issue-confirm-panel",
  ReportIssueListPanel: "report-issue-list-panel",
} as const;

export type ReportIssueKeyType = (typeof ReportIssueKey)[keyof typeof ReportIssueKey];

export type UseReportIssueProps = {
  status: string;
  subName: string;
  subId: string;
  requestId: string;
  intervals: IntervalModel[];
  school: SchoolModel;
  initialState?: {
    initialPanel?: ReportIssueKeyType;
    initialSelectedIntervalId?: number;
  };
};

type ReportIssuePanelProps = {
  goToPanel: (panelKey: ReportIssueKeyType) => void;
  extraProps: UseReportIssueProps;
};

export type ReportIssueModalProps = ReportIssuePanelProps & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setState: Dispatch<any>;
  onDismiss: () => void;
};
